import TableFragment from "./TableFragment";

/**
 * Каждый элемент в массиве имеет одинаковое значение рассматриваемого свойства.
 * Эта функция извлекает это значение и проверяет, что оно действительно совпадает у всех элементов.
 *
 * @param {A[]} arr - массив
 * @param {(x: A) => B} f - свойство
 * @param {string} template - шаблон сообщения об ошибке
 * @return {B}
 * @template A
 * @template B
 */
function getProperty(arr, f, template = "Elements of the array %values are expected to be equal") {
  if (!arr.length) throw new Error('An array must be non-empty');
  const values = arr.map(f);
  const v = values[0];
  if (values.every((u) => v === u || JSON.stringify(v) === JSON.stringify(u))) {
    return v;
  }
  const valuesStr = values.map((x) => '\n- ' + JSON.stringify(x)).join('') + '\n';
  throw new Error(template.replace(/%values/, valuesStr));
}

function accumulate(arr) {
  const res = [...arr];
  let s = 0;
  for (let i = 0; i < arr.length; ++i) {
    res[i] = s;
    s += arr[i];
  }
  return [res, s];
}

/**
 * Объединение квадратной таблицы из согласующихся по размерам фрагментов
 * @param {ExcelTableFragment[][]} fragments - таблица из фрагментов
 * @return {ExcelTableFragment}
 */
export default function mergeFragments(fragments) {
  console.log(fragments);
  const mc = fragments.length; // количество фрагментов по вертикали
  if (mc === 0) throw new Error('mergeGrid requires non-empty matrix');
  const nc = getProperty(fragments, (frags) => frags.length, 'fragments must be a rectangular matrix'); // количество фрагментов по горизонтали
  if (nc === 0) throw new Error('mergeGrid requires non-empty matrix');
  const ns = getProperty(fragments, (frags) => frags.map((frag) => frag.n), 'Array of n must be the same for each row of fragments: %values'); // массив ширин
  const ms = fragments.map((fs) => getProperty(fs, (frag) => frag.m, 'Value of m must be the same for each fragments in a row: %values')); // массив высот
  const [ans, nres] = accumulate(ns);
  const [ams, mres] = accumulate(ms);

  const data = Array(mres).fill(0).map(() => Array(nres).fill(1));
  const markdown = [];
  const columnWidth = Array(nres);
  const rowHeight = Array(mres);

  for (let i = 0; i < nc; ++i) {
    for (let j = 0; j < mc; ++j) {
      const frag = fragments[j][i];
      console.log('merge', frag);
      const x0 = ans[i];
      const y0 = ams[j];
      for (let dx = 0; dx < frag.n; ++dx) {
        for (let dy = 0; dy < frag.m; ++dy) {
          data[y0 + dy][x0 + dx] = frag.data[dy][dx];
        }
      }
      markdown.push(...frag.markdown.map((md) => md.shift(x0, y0)));
      for (let dx = 0; dx < frag.n; ++dx) {
        if (frag.columnWidth[dx] === undefined)
          continue;
        if (columnWidth[x0 + dx] !== undefined && JSON.stringify(columnWidth[x0 + dx]) !== JSON.stringify(frag.columnWidth[dx]))
          throw new Error(`columnWidth mismatches: ${JSON.stringify(columnWidth[x0 + dx])} and ${JSON.stringify(frag.columnWidth[dx])}`);
        columnWidth[x0 + dx] = frag.columnWidth[dx];
      }
      for (let dy = 0; dy < frag.m; ++dy) {
        if (frag.rowHeight[dy] === undefined)
          continue;
        if (rowHeight[y0 + dy] !== undefined && JSON.stringify(rowHeight[y0 + dy]) !== JSON.stringify(frag.rowHeight[dy]))
          throw new Error(`rowHeight mismatches: ${JSON.stringify(rowHeight[y0 + dy])} and ${JSON.stringify(frag.rowHeight[dy])}`);
        rowHeight[y0 + dy] = frag.rowHeight[dy];
      }
    }
  }

  return new TableFragment([nres, mres], { data, markdown, columnWidth, rowHeight });
}

/*
// ТЕСТОВЫЙ ПРИМЕР

const frag1 = new TableFragment([3, 2], {
  data: [[0, 1, 2], [3, 4, 5]],
  markdown: [],
  columnWidth: [{}, {}, {}],
  rowHeight: [{}, {}],
});

const frag2 = new TableFragment([2, 2], {
  data: [[10, 11], [13, 14]],
  markdown: [],
  columnWidth: [{}, {}],
  rowHeight: [{}, {}],
});

const frag3 = new TableFragment([3, 1], {
  data: [[6, 7, 8]],
  markdown: [],
  columnWidth: [{}, {}, {}],
  rowHeight: [{}],
});

const frag4 = new TableFragment([2, 1], {
  data: [[0, 0]],
  markdown: [],
  columnWidth: [{}, {}],
  rowHeight: [{}],
});

const fragm = mergeFragments([
  [frag1, frag2],
  [frag3, frag4],
]);

console.warn(fragm);
*/
